import defaultSchema from './default.schema';

export default {
  ...defaultSchema,
  type: 'object',
  properties: {
    collectionPointId: {
      type: 'number',
      title: 'Punkt odbioru *',
      fieldRequired: true
    }
  }
};
